import {
  ApiResponse,
  TransactionGridResponse,
  TransactionSearchParams,
} from '../../types/types';
import { client } from '../client';
import { urls } from '../endpoints';

export const getTransactions = async (params?: TransactionSearchParams) => {
  try {
    const response = await client.get<ApiResponse<TransactionGridResponse>>(
      urls.searchTransactions(params),
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
